.settingsHeader {
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: stretch;
	margin-bottom: 20px;
}

.settingsGrid {
	display: grid;
	gap: 18px;
	grid-template-columns: 1fr;
}

.settingsCard {
	display: grid;
	gap: 14px;
}

.diagnosticsUnlock, .logsHeader {
	display: flex;
	gap: 10px;
	align-items: center;
	flex-wrap: wrap;
}

.diagnosticsPrompt {
	display: flex;
	gap: 10px;
	align-items: center;
	flex-wrap: wrap;
}

.diagnosticsUnlock input {
	min-height: 40px;
	padding: 8px 12px;
	border: 1px solid var(--border);
	border-radius: 999px;
	background: var(--code-bg);
	color: var(--text);
}

.diagnosticsError { color: #ef4444; }

.logViewer {
	max-height: 420px;
	overflow: auto;
	white-space: pre-wrap;
	font-size: 0.78rem;
	padding: 12px;
	border: 1px solid var(--border);
	border-radius: 10px;
	background: var(--code-bg);
}

.progressStat {
	display: flex;
	align-items: center;
	gap: 6px;
}

.progressCountButton {
	padding: 0 2px;
	border: 0;
	background: transparent;
	color: var(--accent);
	font: inherit;
	font-weight: 700;
	text-decoration: underline;
	text-underline-offset: 3px;
	cursor: pointer;
}

.progressCountButton:disabled {
	text-decoration: none;
	cursor: default;
}

.progressShowList {
	flex-basis: 100%;
	margin: 0;
	padding: 0 0 0 20px;
	color: var(--text);
}

.progressShowList[hidden] {
	display: none;
}

.progressShowList li + li {
	margin-top: 6px;
}

.progressShowLink {
	color: var(--accent);
	text-decoration: underline;
	text-underline-offset: 3px;
}

@media (min-width: 860px) {
	.settingsGrid {
		grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	}
}
